import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m11.05 6.9-.6.45zm-6.8-1.65H8.5v-1.5H4.25zM3.5 18V6H2v12zm16.25.75H4.25v1.5h15.5zM20.5 9v9H22V9zm-.75-2.25h-7.5v1.5h7.5zm-8.1-.3-1.35-1.8-1.2.9 1.35 1.8zm.6.3a.75.75 0 0 1-.6-.3l-1.2.9a2.25 2.25 0 0 0 1.8.9zM22 9a2.25 2.25 0 0 0-2.25-2.25v1.5a.75.75 0 0 1 .75.75zm-2.25 11.25A2.25 2.25 0 0 0 22 18h-1.5a.75.75 0 0 1-.75.75zM2 18a2.25 2.25 0 0 0 2.25 2.25v-1.5A.75.75 0 0 1 3.5 18zM8.5 5.25a.75.75 0 0 1 .6.3l1.2-.9a2.25 2.25 0 0 0-1.8-.9zm-4.25-1.5A2.25 2.25 0 0 0 2 6h1.5a.75.75 0 0 1 .75-.75z" }, null, -1)
  ]))]))
}
export default { render: render }